import { WEBSITE_BUILDER_CURRENT_SCHEMA_VERSION } from "../../schema/websiteBuilderCurrentSchemaVersion";
import { TWebsiteBuilderNode } from "../websiteBuilderNode";
import {
  IWebsiteBuilderSectionBase,
  IWebsiteBuilderSectionDataBase,
  websiteBuilderGenerateDefaultSectionBackground,
} from "./websiteBuilderSection";

export const WEBSITE_BUILDER_HEADER_ID = "header";

export interface IWebsiteBuilderHeaderData extends IWebsiteBuilderSectionDataBase {
  type: typeof WEBSITE_BUILDER_HEADER_ID;
}

export interface IWebsiteBuilderHeader extends IWebsiteBuilderSectionBase {
  id: typeof WEBSITE_BUILDER_HEADER_ID;
  schemaVersion: number;
  section: IWebsiteBuilderHeaderData;
}

export function isWebsiteBuilderHeader(node: TWebsiteBuilderNode): node is IWebsiteBuilderHeader {
  return node.id === WEBSITE_BUILDER_HEADER_ID && node?.type === "section" && node.section?.type === "header";
}

export function websiteBuilderGenerateDefaultHeader(): IWebsiteBuilderHeader {
  return {
    id: "header",
    type: "section",
    schemaVersion: WEBSITE_BUILDER_CURRENT_SCHEMA_VERSION,
    section: {
      type: "header",
      layout: {
        desktop: {
          height: 100,
        },
        tablet: {
          height: 100,
        },
        mobile: {
          height: 100,
        },
      },
      background: websiteBuilderGenerateDefaultSectionBackground(),
    },
    children: [],
  };
}
